import { Modal, Space, Table, Tooltip, Input, Popconfirm, Select, Button } from "antd";
import React from "react";
import { withRouter } from "../../components/withRouter";
import Header from "../../components/Header";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  UnorderedListOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { openNotification } from "../../functions";

const { Option } = Select;

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRole: false,
      clientName: "",
      products: [],
      editProduct: false,
      productModal: false,
      product_price: "",
      product_name: "",
      editProd_id: 0,
    };
    this.customNavFunction = this.customNavFunction.bind(this);
  }

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  customNavFunction() {
    return this.props.navigate("/");
  }

  setRole(rec) {
    this.setState({
      modalRole: true,
      clientName: rec.name + "/" + rec.tgName,
    });
  }

  getProducts() {
    fetch(`https://bot.weddingchelny.ru/api/adm/products`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ products: res.data, editProduct: false });
        }
      }
    });
  }

  ChangeInputValue = (e) => {
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [name]: value });
  };

  ChangeInputPrice = (e) => {
    let regex = /^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$/;
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (regex.test(value) || value == "") {
      this.setState({ [name]: value });
    }
  };

  savePoint() {
    if (this.state.product_name.trim() == "" || this.state.product_price.trim() == "") {
      return openNotification("Ошибка", 'Поля "Имя" и "Цена" должны быть заполнены', 1, 3.0);
    }
    fetch(
      this.state.editProduct == true
        ? `https://bot.weddingchelny.ru/api/adm/products/` + this.state.editProd_id
        : `https://bot.weddingchelny.ru/api/adm/products/`,
      {
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("ttk"),
        }),
        method: this.state.editProduct == true ? "PATCH" : "POST",
        body: JSON.stringify({
          name: this.state.product_name,
          price: this.state.product_price,
        }),
      }
    ).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({
            productModal: false,
            product_name: "",
            product_price: "",
          });
          this.getProducts();
        }
      }
    });
  }

  render() {
    const columns = [
      {
        title: "Название",
        dataIndex: "p_name",
        key: "p_name",
      },
      {
        title: "Цена",
        dataIndex: "p_price",
        key: "p_price",
      },
      {
        title: "Действия",
        dataIndex: "events",
        key: "events",
        render: (text, record) => {
          return (
            <Space size="large">
              <Tooltip title="Изменить">
                <EditOutlined
                  onClick={() => {
                    this.setState({
                      editProduct: true,
                      product_name: record.p_name,
                      product_price: record.p_price,
                      productModal: true,
                      editProd_id: record.key,
                    });
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </Space>
          );
        },
      },
    ];

    return (
      <div>
        <Header />
        <div className="container">
          <Space>
            <h1>Товары</h1>
            <Button
              onClick={() => {
                this.setState({
                  editProduct: false,
                  product_name: "",
                  product_price: "",
                  productModal: true,
                  editProd_id: 0,
                });
              }}
              type="primary"
            >
              Создать товар
            </Button>
          </Space>
          <Table columns={columns} dataSource={this.state.products} />
          <Modal
            title={"Товар"}
            open={this.state.productModal}
            onOk={() => {
              this.savePoint(0);
            }}
            onCancel={() => {
              this.setState({ editProduct: false, product_name: "", product_price: "", productModal: false });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <div>
                <div>Название</div>
                <Input
                  name="product_name"
                  value={this.state.product_name}
                  onChange={this.ChangeInputValue.bind(this)}
                />
              </div>
              <div>
                <div>Цена</div>
                <Input
                  name="product_price"
                  value={this.state.product_price}
                  onChange={this.ChangeInputPrice.bind(this)}
                />
              </div>
            </Space>
          </Modal>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.getProducts();
  }
}

export default withRouter(Products);
